module.exports = __webpack_public_path__ + "media/images/urgent_care-9fe91d648241bcfbe7ee4f84c5487357.svg";